const state = {
  isBiometricsLoginDisabled: false
}

const getters = {
  getIsBiometricsLoginDisabled (state) {
    return state.isBiometricsLoginDisabled
  }
}

const mutations = {
  setIsBiometricsLoginDisabled (state, value) {
    state.isBiometricsLoginDisabled = value
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/auth.js